import curd from '../curd'
const BASE_PATH = '/rule/alarm/config'

export default curd(BASE_PATH, {
  alarmRuleSave: (data) => ({
    url: BASE_PATH,
    method: 'POST',
    data
  }),
  alarmRuleUpdate: data => ({
    url: BASE_PATH,
    method: 'PUT',
    data
  }),
  pageAlarmList: (params) => ({
    url: `${BASE_PATH}/pageList`,
    method: 'GET',
    params: params
  }),
  updAlarmStatus: (params) => ({
    url: `${BASE_PATH}/updStatus`,
    method: 'POST',
    params: params
  }),
  delAlarmConfig: (params) => ({
    url: BASE_PATH,
    method: 'DELETE',
    params: params
  }),
  getUserList: () => ({
    url: `${BASE_PATH}/getUserList`,
    method: 'GET'
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/AlarmRuleConfig.js